let translations = {
  // ********************************************************
  //
  // SIMPLIFIED CHINESE
  //
  // ********************************************************
  cn: {
    page_title: '页面标题',
    wechat: {
      generic: {
        title: '测试标题',
        desc: '测试说明',
        moments: '测试朋友圈'
      }
    }
  },

  // ********************************************************
  //
  // ENGLISH
  //
  // ********************************************************
  en: {
    page_title: 'PAGE_TITLE',
    wechat: {
      generic: {
        title: 'TEST_TITLE',
        desc: 'TEST_DESC',
        moments: 'TEST_MOMENTS'
      }
    }
  }
}

module.exports = translations
